var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.66406 3.08008C5.66406 9.5428 7.80994 17.1601 10.9828 17.1601C14.1556 17.1601 16.3349 9.5824 16.3349 3.08008H5.66406Z",
    stroke: "#FF7500",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2233 6.22021H11.3796V10.5002H11.0948V7.63994V7.13994H10.5948H10.1794C10.4782 7.03494 10.7149 6.8758 10.8971 6.68894C11.0469 6.53525 11.1515 6.37151 11.2233 6.22021Z",
    stroke: "#FF7500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2803 4.83982C16.2803 3.62498 17.2655 2.63982 18.4803 2.63982C19.6952 2.63982 20.6803 3.62498 20.6803 4.83982C20.6803 7.78782 15.4003 10.9844 15.4003 12.3198C15.4003 12.7598 15.6203 13.1998 16.2803 13.1998M5.72031 13.1998C6.20651 13.1998 6.60031 12.806 6.60031 12.3198C6.60031 10.9844 1.32031 7.78782 1.32031 4.83982C1.32031 3.62498 2.30547 2.63982 3.52031 2.63982C4.73515 2.63982 5.72031 3.62498 5.72031 4.83982M16.2803 3.07982H5.72031C5.23411 3.07982 4.84031 2.68602 4.84031 2.19982C4.84031 1.71362 5.23411 1.31982 5.72031 1.31982H16.2803C16.7665 1.31982 17.1603 1.71362 17.1603 2.19982C17.1603 2.68602 16.7665 3.07982 16.2803 3.07982Z",
    stroke: "#FF7500",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.68016 18.9198V16.8804M15.8402 20.6798H6.16016C6.16016 19.7078 6.9482 18.9198 7.92016 18.9198H14.0802C15.0521 18.9198 15.8402 19.7078 15.8402 20.6798ZM12.3202 16.8804V18.9198V16.8804Z",
    stroke: "#FF7500",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.f66b37ae3d416ed6e0fa6f35e7551ed9.svg";
export { ForwardRef as ReactComponent };